'use client'
import { useState, useRef } from 'react'
import { Dialog } from '@headlessui/react'
import Link from 'next/link'
import { FaLine, FaWhatsappSquare, FaPhoneSquareAlt, FaYoutube, FaLinkedin, FaTiktok } from 'react-icons/fa'
import { AiFillInstagram, AiFillFacebook, /*AiFillTwitterSquare,*/ AiFillWechat } from 'react-icons/ai'
import { IoClose, IoLogoWhatsapp } from "react-icons/io5";
import tailwindConfig from '@tailwind.config'
import QRCodeGenerator from '@components/QRCodeGenerator'

const AgentPageContact = ({ agent, dictionary }) => {
    const [phoneQrIsOpen, setPhoneQrIsOpen] = useState(false)  
    const [waQrIsOpen, setWaQrIsOpen] = useState(false)  
    const [lineQrIsOpen, setLineQrIsOpen] = useState(false)  
    const [isCopied, setIsCopied] = useState(false);
    const spanRef = useRef(null);

    const copyToClipboard = () => {
        if (spanRef && spanRef.current) {
          const tempInput = document.createElement('input');
          tempInput.value = agent.phone.split(':')[1]
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000); // Reset copied state after 2 seconds
        }
    };

    return (
        <div className='w-full justify-between sm:justify-start items-start flex flex-col'>
                        {agent.whatsapp && (
                <>
                    <div className='md:hidden flex w-full'>
                        <Link href={agent.whatsapp} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                            <FaWhatsappSquare
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>Whatsapp</span>
                        </Link>
                    </div>
                    <div className='md:flex hidden w-[250px]'>
                        <button onClick={() => {setWaQrIsOpen(true)}} title='WhatsApp' href={`${agent.whatsapp}`} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' >
                            <IoLogoWhatsapp
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>Whatsapp</span>
                        </button>
                    </div>
                    <Dialog
                        open={waQrIsOpen}
                        onClose={() => setWaQrIsOpen(false)}
                        className="relative z-[1000]"
                    >
                        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                            {/* The actual dialog panel  */}
                            <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                <Dialog.Title>
                                    <div className='flex flex-row justify-between items-center'>
                                        <span className='text-maincolor'>
                                            {agent.agentName}'s WhatsApp
                                        </span>
                                        <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setWaQrIsOpen(false)}}>
                                            <IoClose 
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.light}
                                            />
                                        </button>
                                    </div>
                                </Dialog.Title>
                                <div className='flex flex-col items-center'>
                                    <QRCodeGenerator url={`${agent.whatsapp}`} dictionary={dictionary} />
                                    <div className='w-full flex flex-row justify-center items-center'>
                                        <Link className='w-full bg-[#25D366] text-light p-2 rounded-md text-center' href={agent.whatsapp} target='_blank'>Open WhatsApp in Web Browser</Link>
                                        {/* <span ref={spanRef} className='text-maincolor'>{property.agent.agentContact}</span> */}
                                        {/* <button onClick={copyToClipboard} className='bg-maincolor text-light p-2 rounded-md ml-4'>{isCopied ? 'Copied!' : 'Copy'}</button> */}
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </div>
                    </Dialog>
                </>
            )}

            {agent.line && (
                <>
                    <div className='md:hidden flex w-full'>
                        <Link href={agent.line} className='flex flex-row my-1 justify-center w-full inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                            <FaLine
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>LINE</span>
                        </Link>
                    </div>
                    <div className='md:flex hidden w-[250px]'>
                        <button onClick={() => {setLineQrIsOpen(true)}} title='LINE' href={agent.line} className='flex flex-row my-1 justify-center w-full inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                            <FaLine
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>LINE</span>
                        </button>
                    </div>
                    <Dialog
                        open={lineQrIsOpen}
                        onClose={() => setLineQrIsOpen(false)}
                        className="relative z-[1000]"
                    >
                        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                            {/* The actual dialog panel  */}
                            <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                <Dialog.Title>
                                    <div className='flex flex-row justify-between items-center'>
                                        <span className='text-maincolor'>
                                            {agent.agentName}'s LINE
                                        </span>
                                        <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setLineQrIsOpen(false)}}>
                                            <IoClose 
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.light}
                                            />
                                        </button>
                                    </div>
                                </Dialog.Title>
                                <div className='flex flex-col items-center'>
                                    <QRCodeGenerator url={`${agent.line}`}  dictionary={dictionary} />
                                    <div className='w-full flex flex-row justify-center items-center'>
                                        {/* <Link className='w-full bg-[#25D366] text-light p-2 rounded-md text-center' href={property.agent.agentLine}>Open WhatsApp in Web Browser</Link> */}
                                        {/* <span ref={spanRef} className='text-maincolor'>{property.agent.agentContact}</span> */}
                                        {/* <button onClick={copyToClipboard} className='bg-maincolor text-light p-2 rounded-md ml-4'>{isCopied ? 'Copied!' : 'Copy'}</button> */}
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </div>
                    </Dialog>
                </>
            )}
            {agent.phone && (
                <>
                    <div className='md:hidden flex w-full'>
                        <Link href={agent.phone} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#FF0000] to-[#e90b0b] hover:from-[#e90b0b] hover:to-[#FF0000] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                            <FaPhoneSquareAlt
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>Phone</span>
                        </Link>
                    </div>
                    <div className='md:flex hidden w-[250px]'>
                        <button onClick={() => {setPhoneQrIsOpen(true)}} title='Mobile' href={agent.phone} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#FF0000] to-[#e90b0b] hover:from-[#e90b0b] hover:to-[#FF0000] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                            <FaPhoneSquareAlt
                                color={tailwindConfig.theme.extend.colors.light}
                                size={30}
                                className=''
                            />
                            <span className='w-[90px] text-center text-light font-semibold ml-2'>Phone</span>
                        </button>
                    </div>
                    <Dialog
                        open={phoneQrIsOpen}
                        onClose={() => setPhoneQrIsOpen(false)}
                        className="relative z-[1000]"
                    >
                        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                            {/* The actual dialog panel  */}
                            <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                <Dialog.Title>
                                    <div className='flex flex-row justify-between items-center'>
                                        <span className='text-maincolor'>
                                            {agent.agentName}'s Phone Number
                                        </span>
                                        <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setPhoneQrIsOpen(false)}}>
                                            <IoClose 
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.light}
                                            />
                                        </button>
                                    </div>
                                </Dialog.Title>
                                <div className='flex flex-col items-center'>
                                    <QRCodeGenerator url={agent.phone} dictionary={dictionary} />
                                    <div className='w-full flex flex-row justify-center items-center'>
                                        <span ref={spanRef} className='text-maincolor'>{agent.phone.split(':')[1]}</span>
                                        <button title='Click to copy to clipboard' onClick={copyToClipboard} className='bg-maincolor text-light p-2 rounded-md ml-4'>{isCopied ? 'Copied!' : 'Copy'}</button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </div>
                    </Dialog>
                </>
            )}
        {/* {agent.facebook && (
            <Link href={agent.facebook} className='mr-2' target="_blank">
                <AiFillFacebook
                    color={'#1877f2'}
                    size={30}
                    className=''
                />
            </Link>
        )} */}
        {/* {agent.instagram && (
            <Link href={agent.instagram} className='mr-2' target="_blank">
                <AiFillInstagram
                    color={'#e91e63'}
                    size={30}
                    className=''
                />
            </Link>
        )}
        {agent.youtube && (
            <Link href={agent.youtube} className='mr-2' target="_blank">
                <FaYoutube
                    color={'#FF0000'}
                    size={30}
                    className=''
                />
            </Link>
        )}
        {agent.tiktok && (
            <Link href={agent.tiktok} className='mr-2' target="_blank">
                <FaTiktok
                    color={'#000000'}
                    size={30}
                    className=''
                />
            </Link>
        )}
        {agent.linkedin && (
            <Link href={agent.linkedin} className='mr-2' target="_blank">
                <FaLinkedin
                    color={'#0077B5'}
                    size={30}
                    className=''
                />
            </Link>
        )} */}

        </div>
    )
}

export default AgentPageContact